<template>

  <panel-navigation>
    
    <h1 class="text-lg font-semibold mb-3">Radius</h1>

    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box stats-box w-full px-2 -mx-2"  style="height: 100%;">
      <v-card
        class="pa-2 h-full"
        tile
         style="height: 100%;"
      >
        <div v-if="me" :class="'w-full mb-3 p-3'" style="height: 100%;">
            <iframe src="https://lsa-service-area-extractor-395t.vercel.app/" style="width: 100%; height: calc(100% - 100px);"></iframe>
        </div>
      </v-card>
    </div>

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "LSA Service Areas Tool | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
    })
  },

  components: {
    PanelNavigation
  },

  data () {
    return {
      
    }
  },

  methods: {
    
  },

  created() {
    return; 

    /*let self = this;
    tryUpvoty();

    function tryUpvoty() {
      console.log('try upvoty');
      if (!self.profile) {
        setTimeout(function() {
          tryUpvoty();
        }, 100);
        return;
      }

      upvoty.init('identify', {
          user: {
              id: self.profile.id,
              name: self.profile.first_name + " " + self.profile.last_name,
              email: self.profile.email,
          },
          baseUrl: 'accelerate-marketing.upvoty.com',
          publicKey: 'c9cae0d2de0535b6fa060a0119cef172',
      });

      setTimeout(function() {
        upvoty.init('render', {
          'ssoToken': null,
          'baseUrl': 'accelerate-marketing.upvoty.com'
        });
      }, 1000);
    }*/
  }
}
</script>